<template>
    <div class="container-md container-app p-0 ">
        <div class="wrapper">
            <div class="header"><h1>{{$t('ordine_riepilogo')}}</h1></div>
            <div class="content-full">
                <div v-if="this.order">
                    <div class="conferma">
                        <i class="pi pi-thumbs-up f30 my-3"></i><br>
                        <span v-html="$t('ordine_inviato')"></span>
                    </div>
                    <inc-order-content :order="this.order"/>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {mapState, mapActions} from 'vuex';
import {getOrder} from '../../api/account';

import IncOrderContent from './partials/IncOrderContent';

export default {
    name: "Summary",
    components: {IncOrderContent},
    data() {
        return {
            order: null
        }
    },
    created() {
        this.fetch();
    },
    computed: {
        ...mapState('localization', {
            language: state => state.language
        }),
        ...mapState('restaurant', {
            id_ristorante: state => state.id,
            locale: state => state.locale,
            targa: state => state.targa,
        }),
        ...mapState('auth', {
            user: state => state
        })
    },
    methods: {
        fetch: function () {
            this.showLoading(true);
            getOrder(this.language, {
                id_ristorante: this.id_ristorante,
                id_locale: this.locale.id,
                api_key: this.user.api_key,
                id: this.$route.params.id,
                token: this.$route.query.token
            }).then((response) => {
                this.order = response.ordine;
            }).catch(({messages}) => {
                alert(messages.join('\n'));
            }).finally(() => {
                this.showLoading(false);
            })
        },
        ...mapActions('global', [
            'showLoading'
        ])
    }
}
</script>
